export default {
  "content": "<rect width=\"7.2\" height=\"7.2\" x=\"4\" y=\"4\" rx=\"1\"/><rect width=\"7.2\" height=\"7.2\" x=\"12.8\" y=\"4\" rx=\"1\"/><rect width=\"7.2\" height=\"7.2\" x=\"12.8\" y=\"12.8\" rx=\"1\"/><rect width=\"7.2\" height=\"7.2\" x=\"4\" y=\"12.8\" rx=\"1\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "#707070",
    "viewBox": "0 0 24 24"
  }
};